import type { Menu } from '/@/router/types';

const designMenuIconMap: Record<string, string> = {
  首页: 'home-nav-home|svg',
  工作台中心: 'home-nav-home|svg',
  统计: 'home-nav-stat|svg',
  数据看板: 'home-nav-databoard|svg',
  待办: 'home-nav-todo|svg',
  代办: 'home-nav-todo|svg',
  待办中心: 'home-nav-todo|svg',
  合同: 'home-nav-contract|svg',
  合规仪表盘: 'home-nav-compliance-board|svg',
  合规管控: 'home-nav-compliance|svg',
  战略策略: 'home-nav-strategy|svg',
  项目: 'home-nav-project|svg',
  营销项目: 'home-nav-project|svg',
  任务: 'home-nav-task|svg',
  交付物: 'home-nav-deliverable|svg',
  账款: 'home-nav-payment|svg',
  资产: 'home-nav-asset|svg',
  合作机构: 'home-nav-partner|svg',
  合作伙伴: 'home-nav-partner|svg',
  企业伙伴: 'home-nav-partner|svg',
  产品库: 'home-nav-product|svg',
  伙伴: 'home-nav-ally|svg',
  结算平台: 'home-nav-settlement|svg',
  业财融合: 'home-nav-settlement|svg',
  配置中心: 'home-nav-config|svg',
  组织: 'home-nav-org|svg',
  组织管理: 'home-nav-org|svg',
};

function getTopLevelMenuTitle(menu: Menu): string {
  if (typeof menu.name === 'string' && menu.name.trim()) {
    return menu.name.trim();
  }

  if (typeof menu.meta?.title === 'string' && menu.meta.title.trim()) {
    return menu.meta.title.trim();
  }

  return '';
}

function resolveDesignMenuIcon(menu: Menu, depth = 0): Menu {
  const resolvedMenu: Menu = { ...menu };

  if (depth === 0) {
    const menuTitle = getTopLevelMenuTitle(resolvedMenu);
    resolvedMenu.icon = designMenuIconMap[menuTitle] || resolvedMenu.icon;
  }

  if (Array.isArray(resolvedMenu.children) && resolvedMenu.children.length > 0) {
    resolvedMenu.children = resolvedMenu.children.map((child) => resolveDesignMenuIcon(child, depth + 1));
  }

  return resolvedMenu;
}

export function resolveDesignMenuIcons(menus: Menu[]): Menu[] {
  return menus.map((menu) => resolveDesignMenuIcon(menu));
}
